import { SpaceInfo } from 'src/api/types';
import { BookingObject, ProgressState } from 'src/types';

import { SpacesState } from './types';

export const emptySpaces: SpaceInfo[] = [];

export const emptyRemovings = new Set<number>();

export const emptySavings: Record<string, ProgressState> = {};

export const spacesFirstPageNumber = 1;

export const emptyBookingObjects = new Map<string, BookingObject>();

export const emptyRelatedSpaces = new Map<number, SpaceInfo>();

export const initialState: SpacesState = {
  loading: false,
  search: '',
  rows: emptySpaces,
  pageNumber: spacesFirstPageNumber,
  hasMore: true,
  currentRequestId: undefined,
  removings: emptyRemovings,
  savings: emptySavings,
  spaceDialogIsOpen: false,
  space: null,
  mapLoading: false,
  bookingObjects: emptyBookingObjects,
  relatedSpaces: emptyRelatedSpaces,
};
